// extracted by mini-css-extract-plugin
export default {"inputContainer":"TagInputInput-inputContainer-VMO2U"};